import React from "react";
import InnerQuestionOptionsConfigurator from "./InnerQuestionOptionsConfigurator";
import { H5 } from "../wombat-ui";
import useTranslations from "../../hooks/useTranslations";

interface QuestionOptionsConfiguratorProps {
  field;
  fieldIndex;
  register;
  control;
}

const QuestionOptionsConfigurator: React.FC<QuestionOptionsConfiguratorProps> = ({
  field,
  fieldIndex,
  register,
  control,
}) => {
  const t = useTranslations();
  return (
    <>
      <input
        type="hidden"
        name={`questionOptionsConfigurationsAttributes[${fieldIndex}].id`}
        defaultValue={field.id}
        ref={register()}
      />
      <div className="space-y-8">
        <div
          className={`w-full sm:w-7/12`}
        >
          <label className="block text-sm font-medium text-dark-100">
            {t("company.evaluationOptionsConfigLabel")}
          </label>
          <div>
            <InnerQuestionOptionsConfigurator
              name="evaluationQuestionOptionsConfiguration"
              parentFieldIndex={fieldIndex}
              register={register}
              control={control}
            />
          </div>
        </div>
        <div
          className={`w-full sm:w-7/12`}
        >
          <label className="block text-sm font-medium text-dark-100">
            {t("company.skillOptionsConfigLabel")}
          </label>
          <div>
            <InnerQuestionOptionsConfigurator
              name="skillQuestionOptionsConfiguration"
              parentFieldIndex={fieldIndex}
              register={register}
              control={control}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionOptionsConfigurator;
